import { useContext, useEffect, useState } from "react";
import { useLocation } from "wouter";
import { AuthContext } from "~/utils/useAuth";
import { styled, darkTheme } from "~/ui/style/stitches.config";
import { Button } from "~/ui/components/Button";

export const JournalFeatureHeader = ({ onNewEntry }: { onNewEntry?: () => void }) => {
  const { user } = useContext(AuthContext);
  const [, setLocation] = useLocation();

  return (
    <StyledJournalFeatureHeader>
      <div className="content">
        <h1 className="title">Your journal</h1>
        <h3 className="subtitle">
          A space to reflect on your readings. Interpretations from your rooms are saved here automatically.
        </h3>
        {!user ? (
          <div className="button-container">
            <Button
              Theme={"dark"}
              style={{
                width: "144px",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,

                border: "none",
              }}
              onClick={() => window.location.href = "/create-room"}
            >
              Create a room
            </Button>
          </div>
        ) : onNewEntry && (
          <PhysicalEntryButton onClick={onNewEntry}>
            + Physical entry
          </PhysicalEntryButton>
        )}
      </div>
    </StyledJournalFeatureHeader>
  );
};

const PhysicalEntryButton = styled("button", {
  padding: "10px 18px",
  borderRadius: "20px",
  backgroundColor: "rgba(0, 0, 0, 0.04)",
  border: "1px dashed rgba(0, 0, 0, 0.3)",
  fontSize: "12px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  marginTop: "4px",
  [`.${darkTheme.className} &`]: { backgroundColor: "rgba(255, 255, 255, 0.08)", borderColor: "rgba(255, 255, 255, 0.4)", color: "$text", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" } },
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, .15)",
  },
});

const StyledJournalFeatureHeader = styled("div", {
  backgroundColor: "rgb(230, 230, 230)",
  border: "1px solid black",
  width: "calc(90%)",
  margin: "-15px auto 34px auto",
  borderRadius: "33px",
  padding: "50px 40px",
  [`.${darkTheme.className} &`]: { backgroundColor: "$appBg", borderColor: "rgba(255, 255, 255, 0.6)", "& .title, & .subtitle": { color: "$text" } },

  "@mobile": {
    width: "100%",
    margin: "10px auto 34px auto",
  },

  "& .content": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "400px",
    textAlign: "center",
    
    "@mobile": {
      width: "100%",
      marginLeft: 0,
    },
  },

  "& .title": {
    fontFamily: "GorgeousBaby",
    fontWeight: "200",
    fontSize: "50px",
    marginBottom: "22px",
    marginLeft: "-3px",
    color: "black",
    "@mobile": {
      fontSize: "44px",
    },
  },

  "& .subtitle": {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "1.5",
    marginBottom: "18px",
    color: "black",
  },

  "& .button-container": {
    marginTop: "10px",
    "& button": {
      transition: "all 0.2s ease-in-out",
    },
  },
});
